export enum RoleType {
  Api = 0,
  Web = 1,
}
